import React from 'react'

import {
  CrownFilled, Icon, ShapeHexagon, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf } from 'prop-types'

import { TIER } from 'Pods/Profile/Settings/SubscriptionManagement/constants'

const TIER_GLYPHS = {
  [TIER.ESSENTIALS]: ShapeHexagon,
  [TIER.PREMIUM]: CrownFilled,
}

const GLYPH_SIZES = {
  20: { width: '12', height: '12' },
  24: { width: '14', height: '14' },
}

function TierMark({ tier, size = 20 }) {
  return (
    <span
      className={classnames('tier-mark', `tier-mark--${tier}`, `tier-mark--size-${size}`)}
      aria-hidden="true"
    >
      <Icon
        svgComponent={TIER_GLYPHS[tier]}
        size={GLYPH_SIZES[size]}
        className={classnames('tier-mark__glyph', `tier-mark__glyph--${tier}`)}
        notSpaced
      />
    </span>
  )
}

TierMark.propTypes = {
  tier: oneOf([TIER.ESSENTIALS, TIER.PREMIUM]).isRequired,
  size: oneOf([20, 24]),
}

export default TierMark
